import { Styles } from "../../../../types/common";

const styles: Styles = {
  select: {
    "& .filter_drop__control--is-focused": {
      borderColor: "#23085A",
      boxShadow: "0 0 0 1px #23085A",
    },
    "& .filter_drop__control--menu-is-open": {
      borderColor: "#23085A",
      boxShadow: "0 0 0 1px #23085A",
    },
    "& .filter_drop__menu": {
      marginTop: "2px",
    },
    "& .filter_drop__indicator-separator": {
      display: "none",
    },
    "& .select_box_label": {
      fontSize: "16px",
      fontWeight: "400",
    },
    "& .select_box_subLabel": {
      fontSize: "14px",
      fontWeight: "400",
      margin: "5px 0",
    },
    "& .filter_drop__menu-list::-webkit-scrollbar": {
      background: "#F0FCF8",
    },
    "& .filter_drop__menu-list::-webkit-scrollbar-thumb": {
      background: "#035C67",
    },
    "& .form_drop__menu-list::-webkit-scrollbar": {
      background: "#F0FCF8",
    },
    "& .form_drop__menu-list::-webkit-scrollbar-thumb": {
      background: "#035C67",
    },
  },
};

export default styles;
